
import React from 'react';
import { useBooking } from '../../context/BookingContext';
import BookingProgress from './BookingProgress';
import DoctorSelection from './DoctorSelection';
import DateTimeSelection from './DateTimeSelection';
import PatientDetailsForm from './PatientDetailsForm';
import AppointmentReview from './AppointmentReview';
import AppointmentConfirmation from './AppointmentConfirmation';

const BookingContainer: React.FC = () => {
  const { state } = useBooking();
  const { step } = state;

  const renderStep = () => {
    switch (step) {
      case 1:
        return <DoctorSelection />;
      case 2:
        return <DateTimeSelection />;
      case 3:
        return <PatientDetailsForm />;
      case 4:
        return <AppointmentReview />;
      case 5:
        return <AppointmentConfirmation />;
      default:
        return <DoctorSelection />;
    }
  };

  return (
    <div className="max-w-5xl mx-auto px-4">
      {step < 5 && <BookingProgress />}
      {renderStep()}
    </div>
  );
};

export default BookingContainer;
